import React from 'react'
import { IResidenceDetailSecondaryProps } from './residence-detail-secondary-props.interface'
import './residence-detail-secondary.scss'
import { t } from 'i18next'

const ResidenceDetailSecondary: React.FC<IResidenceDetailSecondaryProps> = ({ residence }) => {
  return (
    <div className="edisu-residence-detail-secondary">
      {residence.note && (
        <div className="residence-notes residence-detail-spaced">
          <p className="residence-detail-title">{t('additional_notes').toUpperCase()}</p>
          <span className="residence-detail-text">{residence.note}</span>
        </div>
      )}
    </div>
  )
}

export default ResidenceDetailSecondary
